export const removeGlobalLoader = () => document.querySelector('.ls-loading-logo')?.remove();
